import { keepPreviousData } from '@tanstack/vue-query';

export function useHomepageProperties() {
  return useQuery({
    queryKey: [`homepage-properties`],
    placeholderData: keepPreviousData,
    queryFn: () => {
      return $fetch(`/api/homepage`, {
        method: 'GET',
      });
    },
    retry: 0,
  });
}
